import classNames from 'classnames/bind';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import styles from './index.less';

const cx = classNames.bind(styles);

const BackToPrev = ({ backLink, backText }) => (
  <Link to={backLink}>
    <Icon type="left" />
    <span className={cx('backtoprev-text')}>{backText}</span>
  </Link>
);

BackToPrev.defaultProps = {
  backLink: '',
  backText: null,
};
BackToPrev.propTypes = {
  backLink: PropTypes.string,
  backText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default BackToPrev;



// WEBPACK FOOTER //
// ./src/components/ui/BackToPrev/index.jsx